import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

const apiUrl = 'https://production.api';
const hhApiUrl = 'https://api-homehealth.portalct.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  hhApiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
